import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import useModal from '@hooks/ui/useModal';
import { useAtom } from 'jotai';
import { Fragment } from 'react';

import { isDeletingAtom } from '../../atoms/myMenuAtoms';

function MyMenuFooter() {
  const [isDeleting, setIsDeleting] = useAtom(isDeletingAtom);
  const { openModal, closeModal } = useModal();
  const handleDelete = () => {
    setIsDeleting(false);
    openModal(<Column align='center' fullWidth spacing={40}>
        <Text align='center'>삭제되었습니다.</Text>
        <Button fullWidth onClick={closeModal}>확인</Button>
    </Column>);
  };
  if (isDeleting) {
    return (
          <Row spacing={12} fullWidth>
              <Button variant='secondary' fullWidth size='sm'>취소</Button>
              <Button fullWidth size='sm' onClick={handleDelete}>
                  삭제
              </Button>
          </Row>
    );
  }
  return (<Fragment/>);
}

export default MyMenuFooter;
